/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontAboutSection_seller$ref = any;
type StorefrontArticleSection_seller$ref = any;
type StorefrontFeaturedSection_seller$ref = any;
type StorefrontMediaSection_seller$ref = any;
export type StorefrontHome_seller$ref = any;
export type StorefrontHome_seller = {
    readonly " $fragmentRefs": StorefrontAboutSection_seller$ref & StorefrontMediaSection_seller$ref & StorefrontArticleSection_seller$ref & StorefrontFeaturedSection_seller$ref;
    readonly " $refType": StorefrontHome_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontHome_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontAboutSection_seller",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "StorefrontMediaSection_seller",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "StorefrontArticleSection_seller",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "StorefrontFeaturedSection_seller",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'a142c6465ca03df1e7974b2e95cb721c';
export default node;
